module.exports = __webpack_public_path__ + "img/training2.7d90da31.jpeg";